import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, TextInput } from 'ionic-angular';

//i18n
import { TranslateService } from '@ngx-translate/core';

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';
import { ClockIn } from '../../modules/sbsuite/models/clock-in.model';
import moment from 'moment';

//Models
import { Product } from '../../modules/sbsuite/models/product.model';
import { APP_DI_CONFIG} from '../../app/app-config.module';


/**
 * Componente para añadir/editar fichadas de forma manual
 *
 * @export
 * @class EditClockIn
 * @implements {OnDestroy}
 */
@Component({
    selector: 'page-edit-clock-in',
    templateUrl: 'edit-clock-in.html',
    styles: [`
    ion-label[label-gray]{
        color: #999;
    }

    time-input .label{
        color: #999;
    }
    `]
})
export class EditClockIn{

    @ViewChild('moInput') moInput: TextInput;

    /**
     * Fichada objectivo.
     *
     * @type {ClockIn}
     * @memberof EditClockIn
     */
    clockIn: ClockIn = new ClockIn;


    /**
     * Tiempo de inicio.
     *
     * @type {string}
     * @memberof EditClockIn
     */
    start: string = '00:00';


    /**
     * Tiempo de fin.
     *
     * @type {string}
     * @memberof EditClockIn
     */
    end: string = '00:00';

    /**
     * Flag para controlar el focus de la OF.
     *
     * @type {boolean}
     * @memberof EditClockIn
     */
    focusedMO: boolean = false;


    /**
     * Flag para controlar el SELECT de producto.
     *
     * @type {boolean}
     * @memberof EditClockIn
     */
    focusedProduct: boolean = false;


    /**
     * Flag para controlar el SELECT de operación.
     *
     * @type {boolean}
     * @memberof EditClockIn
     */
    focusedOperation: boolean = false;

    /**
     * Mascara de OF.
     *
     * @type {string}
     * @memberof EditClockIn
     */
    maskMO: string = new Date().getFullYear().toString().substr(-2) + '0000';


    /**
     * Crea una instancia de EditClockIn.
     * 
     * @param {NavController} navCtrl //Controlador de navegación de ionic.
     * @param {NavParams} navParams //Controlador de parametros de navegación de ionic.
     * @param {TranslateService} translateService //Servicio de traducciones.
     * @param {SBSuiteManager} sbSuiteManager //Gestor de sbSuite.
     * @memberof EditClockIn
     */
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public translateService: TranslateService,
        public sbSuiteManager: SBSuiteManager
    ){
        this.initTime();
        this.initData();
    }

    /**
     * Inicia los tiempos de la fichada con la hora de inicio actual y la hora final (una hora mas)
     *
     * @private
     * @memberof EditClockIn
     */
    private initTime(): void{
        let now = new Date();
        let hour = now.getHours();
        let minutes = now.getMinutes();
        this.start =  hour.toString() + ':' + minutes.toString();
        now.setHours(hour+1);
        this.end = now.getHours() + ':' + '6'.toString();
    }

    /**
     * Inicia el formulario de datos con una fichada del historial.
     * 
     * Si no hay selección se inicia con una fichada vacía.
     *
     * @private
     * @memberof EditClockIn
     */
    private initData(){
        //Recupera la fichada manual y assigna el operario
        this.sbSuiteManager.sbSuite.manually = this.sbSuiteManager.sbSuite.getManuallyInHistory().copy();
        this.clockIn = this.sbSuiteManager.sbSuite.manually;
        let clockIn = this.sbSuiteManager.sbSuite.manually;
        clockIn.operator = this.sbSuiteManager.sbSuite.manuallyOperator;

        if(!this.sbSuiteManager.sbSuite.isManuallyEmpty()){
            this.sbSuiteManager.getDropdowns(clockIn.manufacturingOrder,clockIn.products[0].code,'manually');
        }
        else{
            let maxEnd = this.sbSuiteManager.sbSuite.getMaxHistoryEnd(); 
            let maxEnd2 = moment(maxEnd, APP_DI_CONFIG.dateMask).add(1, 'hours').format(APP_DI_CONFIG.dateMask);
            this.clockIn.start = maxEnd;
            this.clockIn.end = maxEnd2;
        }
    }


    /**
     * Controla que los datos especificados sean correctos.
     *
     * @memberof EditClockIn
     */
    dataControl(){
        if(!this.clockIn.validateUDData()) console.warn('Datos incorrectos');
        else{
            if(this.clockIn.register) this.sbSuiteManager.modHorasOpProdOf(this.clockIn);
            else {
                this.sbSuiteManager.anadirHorasOpProdOf(this.clockIn);
            }

        }

    }
    
    /**
     * Modifica manualmente las observaciones del formulario
     *
     * @param {*} event
     * @memberof EditClockIn
     */
    setObservations(event: any): void{
        this.sbSuiteManager.sbSuite.manuallyObservations = event;
    }

    /**
     * Llama al NavController para quitar la vista
     *
     * @memberof EditClockIn
     */
    popView(): void{
        this.sbSuiteManager.sbSuite.manually = new ClockIn();
        this.navCtrl.pop();
    }

    /**
   * Realiza el focus del input de OF.
   *
   * @memberof EditClockIn
   */
  focusingMO(){
    this.moInput.setFocus();
    this.moInput.value = this.maskMO;
  }

  /**
   * Evento al realizar focus al input de OF.
   *
   * @memberof EditClockIn
   */
  focusMO(){
    this.focusedMO = true;
    this.moInput.value = this.maskMO;
  }

  /**
   * Evento al perder el focus del input de OF.
   *
   * @returns
   * @memberof EditClockIn
   */
  blurMO(){
    this.focusedMO = false;
    let value = this.sbSuiteManager.sbSuite.manuallyOF;
    if(value.length<3) return;
    let prefix = this.maskMO.substr(0,2);
    let val = value.substr(2, value.length - 1);
    let dif = this.maskMO.length - (prefix.length + val.length);
    value = prefix;
    for(let i=0; i<dif; i++){
      value += '0';
    }
    value+= val;
    this.sbSuiteManager.sbSuite.manuallyOF = value;
    if(this.sbSuiteManager.sbSuite.manually) this.sbSuiteManager.getProductosOfDropdown(this.sbSuiteManager.sbSuite.manuallyOF,'manually')
  }

  /**
   * Evento al realizar un cambio al input de operador para pantallas pequeñas.
   *
   * @param {*} event
   * @memberof AutoClocking
   */
  changeMOKP(event: any){
    let exculdeKeys = ['Enter'];
    let key = event.key;
    if(exculdeKeys.indexOf(key)==-1){
      event.preventDefault();
      event.stopPropagation();
      let prefix = this.maskMO.substr(0,2);
      let val = this.sbSuiteManager.sbSuite.manuallyOF.substr(3, this.maskMO.length);
      let value =  this.sbSuiteManager.sbSuite.manuallyOF;
      if(value.length >= this.maskMO.length) value = `${prefix}${val}${key}`;
      else value = `${value}${key}`;
      this.sbSuiteManager.sbSuite.manuallyOF = value;
    } 

  }

    /**
     * Modifica manualmente la orden de fabricación del formulario
     *
     * @param {*} value
     * @returns {vaoid}
     * @memberof EditClockIn
     */
    changeMO(value): void{
        this.sbSuiteManager.sbSuite.manually.manufacturingOrder = value;
        this.sbSuiteManager.getProductosOfDropdown(value,'manually');
    }

    /**
     * Compara los objectos para los ion-select
     *
     * @param {*} p1
     * @param {*} p2
     * @returns {boolean}
     * @memberof EditClockIn
     */
    compareObjs(p1: any, p2: any): boolean {
        return p1 && p2 ? p1.code === p2.code : p1 === p2;
    }


    /**
     * Devuelve el dia de la fichada
     *
     * @returns {string}
     * @memberof EditClockIn
     */
    getDay(): string{
        return moment(this.sbSuiteManager.sbSuite.filterDate,'DD/MM/YYYY').format('YYYY-MM-DD');
    }


    /**
     * @Output para el canvio del SELECT de producto.
     *
     * @param {*} event
     * @param {*} prama
     * @returns
     * @memberof EditClockIn
     */
    changeProduct(event, prama){
        if(!this.focusedProduct) return;
        this.sbSuiteManager.getOpsProdOfDropdown(this.clockIn.getProduct().code, 'manually');
    }


    /**
     * Output para el focus del SELECT de producto.
     *
     * @param {*} event
     * @memberof EditClockIn
     */
    focusProduct(event){
        this.focusedProduct = true;
    }

    /**
     * Output para el blur del SELECT de producto.
     *
     * @param {*} event
     * @memberof EditClockIn
     */
    blurProduct(event){
        this.focusedProduct = false;
    }


    /**
     * Output para el focus del SELECT de operación.
     *
     * @param {*} event
     * @memberof EditClockIn
     */
    focusOperation(event){
        this.focusedOperation = true;
    }


    /**
     * Output para el blur del SELECT de operación.
     *
     * @param {*} event
     * @memberof EditClockIn
     */
    blurOperation(event){
        this.focusedOperation = true;
    }


    /**
     * Ionic live cycle hook.
     * 
     * Reinicia la fichada al salir de la vista.
     *
     * @memberof EditClockIn
     */
    ionViewDidLeave(){
        this.sbSuiteManager.getOfsOperario(this.sbSuiteManager.sbSuite.manuallyOperator, this.sbSuiteManager.sbSuite.getRequestDate());
        this.sbSuiteManager.sbSuite.hIndex = null;
        this.sbSuiteManager.sbSuite.manually = new ClockIn();
    }

}


// WEBPACK FOOTER //
// ./src/pages/manually-clocking/edit-clock-in.ts